import React, { useState, useEffect } from 'react';

const STORAGE_KEY = 'voxsmyth-upgrade-notice-dismissed';

/**
 * One-time popup notice about site upgrade.
 * Shows after the scroll intro, dismissible, stored in localStorage.
 */
const UpgradeNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setVisible(false);
    localStorage.setItem(STORAGE_KEY, 'true');
  };

  if (!visible) return null;

  return (
    <div
      data-testid="upgrade-notice-overlay"
      onClick={dismiss}
      style={{
        position: 'fixed', inset: 0, zIndex: 99990,
        background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        padding: '24px',
        animation: 'fadeIn 0.3s ease',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: '#1A202C',
          border: '1px solid #D7B37740',
          borderRadius: '20px',
          padding: '40px',
          maxWidth: '520px',
          width: '100%',
          boxShadow: '0 24px 60px rgba(0,0,0,0.5)',
          textAlign: 'center',
          position: 'relative',
        }}
      >
        {/* Close button */}
        <button
          onClick={dismiss}
          data-testid="upgrade-notice-close"
          style={{
            position: 'absolute', top: '16px', right: '16px',
            background: 'none', border: 'none', color: '#E8DCC060',
            fontSize: '24px', cursor: 'pointer', lineHeight: 1,
          }}
        >
          &times;
        </button>

        {/* Icon */}
        <div style={{
          width: '64px', height: '64px', borderRadius: '50%',
          background: 'linear-gradient(135deg, #D7B377, #DAA520)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 20px',
          fontSize: '28px',
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L2 7l10 5 10-5-10-5z" stroke="#1A202C" strokeWidth="2" strokeLinejoin="round"/>
            <path d="M2 17l10 5 10-5" stroke="#1A202C" strokeWidth="2" strokeLinejoin="round"/>
            <path d="M2 12l10 5 10-5" stroke="#1A202C" strokeWidth="2" strokeLinejoin="round"/>
          </svg>
        </div>

        <h2 style={{
          fontFamily: 'DM Serif Display, Georgia, serif',
          fontSize: '26px', fontWeight: 700,
          color: '#fff', margin: '0 0 12px',
        }}>
          We've Upgraded VoxSmyth
        </h2>

        <p style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: '15px', lineHeight: 1.7,
          color: '#E8DCC0CC', margin: '0 0 8px',
        }}>
          We've made major improvements to our platform including new AI voices,
          faster audio generation, and multi-voice character narration.
        </p>

        <p style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: '14px', lineHeight: 1.6,
          color: '#D7B377', margin: '0 0 24px',
          fontWeight: 600,
        }}>
          Existing users may need to create a new account to access the upgraded experience.
        </p>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={dismiss}
            data-testid="upgrade-notice-continue"
            style={{
              padding: '12px 32px', borderRadius: '12px', border: 'none',
              background: 'linear-gradient(135deg, #D7B377, #DAA520)',
              color: '#1A202C', fontWeight: 700, fontSize: '15px',
              cursor: 'pointer', fontFamily: 'DM Sans, sans-serif',
              transition: 'transform 0.2s ease',
            }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; }}
          >
            Got it, let's go
          </button>
        </div>

        <p style={{
          fontFamily: 'Inter, sans-serif',
          fontSize: '12px', color: '#E8DCC050',
          margin: '20px 0 0', lineHeight: 1.5,
        }}>
          Questions? Contact <a href="mailto:support@voxsmyth.com" style={{ color: '#D7B377' }}>support@voxsmyth.com</a>
        </p>
      </div>

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
    </div>
  );
};

export default UpgradeNotice;
